import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, showingPageTotalRange, filter, unexpectedError } from '../../common_functions';

const BookList = props => {
  const { section, id } = useParams();
  const [objects, setObjects] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
    await getObjectsData(pagination);
  })();
  }, []);
  const getObjectsData = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      const response = await props.getItems('books', {
        fields: ['id,book_title,publisher,author,editor,edition,date_of_publication,artist.*'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setObjects(response.data);
    } catch (error) {
      console.error(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Book Title',
      dataIndex: 'book_title',
      key: 'book_title',
      sorter: true,
      ...filter('book_title'),
    },
    {
      title: 'Artist',
      dataIndex: 'artist',
      key: 'artist',
      sorter: true,
      render: (text, record) => (
        <span style={{ textTransform: 'capitalize' }}>{!!record.artist && `${record.artist.First_Name} ${record.artist.last_name}`}</span>
      ),
      ...filter('artist'),
    },
    {
      title: 'Publisher',
      dataIndex: 'publisher',
      key: 'publisher',
      sorter: true,
      ...filter('publisher'),
    },
    {
      title: 'Author',
      dataIndex: 'author',
      key: 'author',
      sorter: true,
      ...filter('author'),
    },
    {
      title: 'Editor',
      dataIndex: 'editor',
      key: 'editor',
      sorter: true,
      ...filter('editor'),
    },
    {
      title: 'Edition',
      dataIndex: 'edition',
      key: 'edition',
      sorter: true,
      ...filter('edition'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/bibliography/books/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.bibliography_books?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.bibliography_books?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'books',
              'Book?',
              objects,
              setObjects,
              props?.tabs_permissions.bibliography_books?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  let handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        if (filters[key]) {
          let filterValue = filters[key][0];
          if (key == 'artist') {
            filtersitems['_or'] = [
              { artist: { last_name: { _icontains: filterValue } } },
              { artist: { First_Name: { _icontains: filterValue } } },
            ];
          } else {
            filtersitems[key] = { _icontains: filterValue };
          }
        }
      }
    }
    await getObjectsData(pagination, filtersitems, sorter);
  };

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Bibliography", href: "/bibliography/books" }, { title: "Books" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                Book List
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(props.roleType, props.tabs_permissions.bibliography_books, `/bibliography/books/new`, 'Create Book')}
            </Col>
          </Row>
          <hr />
          <div className="users-list">
            <Table
              rowKey="id"
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              dataSource={objects}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default BookList;
